module.exports = __webpack_public_path__ + "img/1c.0e8ad4e9.png";